module.exports = __webpack_public_path__ + "img/paarfoto_regenschirm_ocular.a6e9b257.jpg";